/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ModalService {
  public showModal: boolean = false;

  private callBackData: any;
  private confirmationCallBack: (data: any) => void = () => {};
  private cancelationCallBack: (data: any) => void = () => {};

  public sendConfirmation(): void {
    this.confirmationCallBack(this.callBackData);
  }

  public sendCancel(): void {
    this.cancelationCallBack(this.callBackData);
  }

  public openConfirmation(
    callBackData: any,
    confirmationCallBack: (data: any) => void,
    cancelationCallBack: (data: any) => void = () => {},
  ): void {
    this.showModal = true;
    this.cancelationCallBack = cancelationCallBack;
    this.confirmationCallBack = confirmationCallBack;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.callBackData = callBackData;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    (document.querySelector('tds-modal') as any)?.showModal();
  }
}
